import AuthService from '@/services/AuthService'
import AccountService from '@/services/AccountService'
import OrderService from '@/services/OrderService'
import CuttingService from '@/services/CuttingService'
import MapsService from '@/services/MapsService'

class UnitOfWorkService {

	constructor() {
		this._authService = new AuthService()
		this._accountService = new AccountService()
		this._orderService = new OrderService()
		this._cuttingService = new CuttingService()
		this._mapService = new MapsService()
	}

	authService() {
		return this._authService
	}
	accountService() {
		return this._accountService
	}
	orderService() {
		return this._orderService
	}
	cuttingService() {
		return this._cuttingService
	}
	mapService() {
		return this._mapService
	}
}

export default UnitOfWorkService